import React, { useCallback } from 'react';
import { Card, Text, Row, Heading } from '../core';
import {
  useCall2,
  useSend,
  useERC20,
  useVaultPageSubgraph,
} from '@sc1/common/hooks';
import { fromNow, formatAmountBN, VaultUpgradable } from '@sc1/common';
import { StatusButton } from '../StatusButton';
import { CardProps } from 'theme-ui';

interface ClaimFeesProps extends CardProps {
  vault: VaultUpgradable | undefined; // TODO: IMPLEMENT FOR SCYVAULT
  disabled: boolean;
}

export const ClaimFees = ({
  vault,
  disabled,
  ...rest
}: ClaimFeesProps): JSX.Element => {
  const { sendTx, txStatus } = useSend();
  const { data } = useVaultPageSubgraph();
  const { lastClaim } = data?.vault || {};

  const { res: underlyingAddress } = useCall2(vault?.UNDERLYING);
  const underlying = useERC20(underlyingAddress);
  const { res: underlyingSymbol } = useCall2(underlying?.symbol);
  const { res: dec } = useCall2(underlying?.decimals);

  const address = vault?.address || '';
  const { res: feesBN } = useCall2(vault?.balanceOf, address);
  const { res: balanceOfUnderlyingBN } = useCall2(
    vault?.balanceOfUnderlying,
    address
  );

  const balanceOfUnderlyingFmt = formatAmountBN(balanceOfUnderlyingBN, dec);

  const claimFees = useCallback(
    () => vault && feesBN != null && sendTx(vault, 'claimFees', [feesBN]),
    [vault, sendTx, feesBN]
  );

  return (
    <Card {...rest}>
      <Text variant="hint" mb={1}>
        Last Claimed{' '}
        {(lastClaim &&
          lastClaim !== '0' &&
          fromNow(Number(lastClaim) * 1000)) ||
          'N/A'}
      </Text>
      <Heading mb={2} as="h3">
        Claim Fees
      </Heading>
      <Row variant="collapse">
        <StatusButton disabled={disabled} onClick={claimFees} status={txStatus}>
          Claim ({balanceOfUnderlyingFmt} {underlyingSymbol})
        </StatusButton>
      </Row>
    </Card>
  );
};
